// import { observable } from "mobx";
import React from 'react';
// tslint:disable-next-line: no-submodule-imports
import { FaTrash } from 'react-icons/fa';

import { DbKey } from '../../../../adl-gen/common/db';
import { UserGroup } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { UserGroupListEntry } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { GroupData } from '../../../../adl-gen/totalinteraction/futurefit/requests';
import { EditIcon } from '../../../../ui/common/icons';
import { Button } from '../../../../ui/widgets/button/button';
import { SelectOption } from '../../../../ui/widgets/select/select';
import { DisplayCheckItem, MultiSelectContainer, DisplayText } from '../../common/editor';

const styles = require('../../common/details-view.css');
const buttonStyles = require('../../common/common.css');

interface GroupDetailsViewProps {
  item: UserGroupListEntry;
  data: GroupData;
  onUpdate(id: DbKey<UserGroup>): Promise<void>;
  role: 'client-admin' | 'super';
}

export class GroupDetailsView extends React.Component<GroupDetailsViewProps> {
  /// TODO: Sort this out later
  private readonly deleteAllowed: boolean = false;

  displayManagerOptions = (): SelectOption[] => {
    const { item, data } = this.props;
    const managers = item.managers
      .map(m => {
        const manager = data.userList.find(u => u.id === m.value.appUserId);
        return { label: manager ? manager.value.fullname : 'notfound', value: m.value.appUserId };
      })
      .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase(), 'en', { sensitivity: 'base' }));
    if (managers.length === 0) {
      return [{ label: 'None', value: '' }];
    } else {
      return managers;
    }
  };

  Name = DisplayText({
    field: this.props.item.name,
    title: 'Name',
    xsSpan: 2
  });
  Global = DisplayCheckItem({
    field: this.props.item.isGlobal,
    label: 'Global',
    xsSpan: 2
  });
  MemberCount = DisplayText({
    field: this.props.item.members.length,
    title: '# Group Members',
    xsSpan: 2
  });

  Managers = MultiSelectContainer({
    options: this.displayManagerOptions(),
    selectedOptions: this.displayManagerOptions(),
    title: 'Group Managers',
    xsSpan: 4
  });

  renderTopButtons = () => {
    const updateButton = () => {
      return (
        <div className={buttonStyles.buttonList}>
          <Button
            // onClick={async () => this.start("update")}
            onClick={async () => this.props.onUpdate(this.props.item.id)}
            Icon={EditIcon}
            size="small"
            variant="round"
            // disabled={this.editable() === undefined}
          >
            Update
          </Button>
        </div>
      );
    };

    const deleteButton = () => {
      return (
        <div className={buttonStyles.buttonList}>
          <Button
            // onClick={async () => this.start("delete")}
            Icon={FaTrash}
            size="small"
            variant="round"
            // disabled={this.selected.size === 0}
          >
            Delete
          </Button>
        </div>
      );
    };

    return (
      <div className={buttonStyles.buttonListContainer}>
        {this.deleteAllowed && deleteButton()}
        {updateButton()}
      </div>
    );
  };

  renderDetails = () => (
    <div className={styles.page}>
      <div className={styles.body}>
        <div>{this.renderTopButtons()}</div>
        <div className={styles.row}>
          {this.Name}
          {this.Global}
        </div>
        <div className={styles.row}>
          {this.MemberCount}
          {this.Managers}
        </div>
      </div>
    </div>
  );

  render() {
    return <React.Fragment>{this.renderDetails()}</React.Fragment>;
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/detail-views/group-details-view.tsx